module.exports = __webpack_public_path__ + "static/media/booked_inactive.781b5e22.svg";